<template>
  <div class="ngp2-container">
    <single-mod :mod="curMod" :valueOp="valueOp" :rightEchart="rightEchart" :up-fn="upChart">
      <template v-slot="wsData">
        <div
          class="device-info"
          v-if="
            wsData.singleDeviceDetail &&
            wsData.singleDeviceDetail.mods &&
            wsData.singleDeviceDetail.mods[curMod]
          "
        >
          <el-row>
            <el-col :span="12">
              <span>设备状态:</span>
              <span class="state" :class="wsData.singleDeviceDetail.state | stateClass(true)">
                {{ wsData.singleDeviceDetail.state | stateText }}
              </span>
            </el-col>
            <el-col :span="12">
              <span>运行状态:</span>
              <span class="state" :class="wsData.singleDeviceDetail.runstate | runstateClass(true)">
                {{ wsData.singleDeviceDetail.runstate | runstateText }}
              </span>
            </el-col>
          </el-row>
          <el-row>
            <div
              style="
                width: 50%;
                margin: 0 auto;
                display: flex;
                justify-content: center;
                font-size: 26px;
              "
            >
              <ModsIcon icon="icon-he" :wsData="wsData.singleDeviceDetail" :mods="curMod" />
            </div>
          </el-row>
          <el-row>
            <div style="margin-bottom: 10px">设备名称: {{ wsData.singleDeviceDetail.name }}</div>
            <div>设备编号: {{ wsData.singleDeviceDetail.sn }}</div>
          </el-row>
        </div>
      </template>
    </single-mod>
  </div>
</template>

<script>
import SingleMod from '../components/single-mod';
import ModsIcon from '@/components/mods-icon';
import { graColor } from '@/views/realdata/FCBR-100/options';
import { lineAreaStyle } from '@/echartOption/lineAreaStyle';
import { concentrations } from '@/utils/dict';

export default {
  name: 'HTDevice',
  components: {
    SingleMod,
    ModsIcon
  },
  data() {
    return {
      curMod: 'nuclearMod',
      concentrations,
      list: [
        {
          title: '设备名称',
          formate: row => row
        }
      ],
      valueOp: [
        {
          title: 'γ剂量率(μSv/h)',
          key: 'radDose'
        },
        {
          title: '经纬度',
          format: v => {
            return this.getCoordinate(v);
          },
          key: 'longitude'
        }
      ],
      rightEchart: [
        lineAreaStyle({
          color: '#833BBB',
          title: { text: 'γ剂量率(μSv/h)', left: 'center' },
          yAxis: { name: 'μSv' },
          series: [
            { areaStyle: { color: graColor('rgba(131, 59, 187, 0.5)', 'rgba(131, 59, 187, 0)') } }
          ]
        })
      ]
    };
  },
  methods: {
    getCoordinate({ mods }) {
      const { longitude, latitude } = mods[this.curMod];
      return `${longitude}, ${latitude}`;
    },
    upChart(newVal) {
      const { beginTime, mods } = newVal;
      const { radDose } = mods[this.curMod];
      this.rightEchart[0].series[0].data.push([beginTime, radDose]);
      if (this.rightEchart[0].series[0].data.length > 20) {
        this.rightEchart[0].series[0].data.shift();
      }
    }
  }
};
</script>

<style lang="scss">
.ngp2-container {
  height: 100%;
  .device-info {
    height: 100%;
    color: #00a0e9;
    font-size: 26px;
    font-weight: bold;
    display: flex;
    flex-direction: column;
    justify-content: space-around;
    .state {
      @include state-textstyle;
    }
  }
  .el-row {
    text-align: center;
  }
}
</style>
